<template>
  <ProductOffers :config = config />
</template>

<script>

export default {
  name: 'CurrentProducts',
  components: {
    ProductOffers: () => import('@/views/products/ProductOffers.vue')
  },
  data () {
    return {
      config: {
        accountType: 'CACC'
      }
    }
  }
}
</script>
